import { Component } from "@mna/react";
import { Trans } from "react-i18next";
import i18next from "i18next";
import Form from "@mna/react-ui/Form";
import terms from "assets/img/terms.png";
import LoadingScreen from "features/LoadingScreen";
import { googleMapsApiKey } from "client.config";
import PlacesAutocomplete from "react-places-autocomplete";
import UserCreatedSuccessfully from "../../features/UserCreatedSuccessfully";
import { commonConstant } from "../../server/triage/constants";
import PhoneInput from 'react-phone-input-2';
import "../../styles/style.scss"

var doBValue;

const initialState = {
	firstErrorMsg: "",
	secondErrorMsg: "",
	dateErrorMsg: "",
	shouldUiBeChanged: false,
};
class Profiles extends Component {
	state = initialState;
	constructor(props) {
		super(props);
		this.state = {
			mapLoaded: false,
			geoAddress: "",
			showError: false,
			shouldUiBeChanged: false,
		};
	}
	initMap = () => {
		this.setState({
			mapLoaded: true,
		});
	};
	componentDidMount() {
		window.initMap = this.initMap;
		const gmapScriptEl = document.createElement(`script`);
		gmapScriptEl.src = `https://maps.googleapis.com/maps/api/js?key=${googleMapsApiKey}&libraries=places&callback=initMap`;
		document
			.querySelector(`body`)
			.insertAdjacentElement(`beforeend`, gmapScriptEl);
	}
	handleGeoChange = (address) => {
		this.setState({ geoAddress: address });
	};

	render() {
		const { state, actions, setState } = this.props;
		{
			const {
				state: { triageRequest },
			} = this.props;
			var dynamicClass;
			if (this.state.showError) {
				dynamicClass =
					"mt-10 mb-10 form-control location-search-input is-error noborder-withbackground text-field w-select";
			} else {
				dynamicClass =
					"mt-10 mb-10 form-control location-search-input noborder-withbackground text-field w-select";
			}
			var homecity = i18next.t(
				"userregistration.homecity"
			)

			return (
				<div className="page-section-2">
					<Form
						className="content content-unset"
						fields={triageRequest.serviceRequest}
						onValidate={(data) => {
							//TODO later needed changes
							// const errors = {};
							// let firstError = "";
							// let secondError = "";
							// let dateError = "";
							// if (data.first === "") {
							//   firstError = "First name cannot be empty";
							//   errors.first = "REQUIRED";
							// } else if (data.first.trim().length <= 2) {
							//   firstError = "Enter the valid first name";
							//   errors.first = "REQUIRED";
							// }
							// this.setState({ firstErrorMsg: firstError });
							// if (data.last === "") {
							//   secondError = "Last name cannot be empty";
							//   errors.last = "REQUIRED";
							// } else if (data.last.trim().length <= 2) {
							//   secondError = "Enter the valid last name";
							//   errors.last = "REQUIRED";
							// }
							// this.setState({ secondErrorMsg: secondError });
							// if (data.date === "") {
							//   dateError = "Date field  cannot be empty";
							//   errors.date = "REQUIRED";
							// }
							// this.setState({ dateErrorMsg: dateError });
							// if (Object.keys(errors).length) return errors;
						}}
						onSubmit={async (values) => {
							state.triageRequest.profiles = values;
							var triageRequests = state.triageRequest;
							if (state.triageRequest.profile && state.triageRequest.profile.date) {
								doBValue = actions.generalDate({
									dateVal: state.triageRequest.profile.date.trim(),
								});
							}
							setState({
								isLoading: true,
							});

							var callOnBoardResponse = await actions.CallOnBoard(
								state,
								setState,
								actions,
								triageRequests,
								doBValue
							);
							if (callOnBoardResponse && callOnBoardResponse.success === commonConstant.true) {
								this.setState({
									shouldUiBeChanged: true,
								});
							} else {
								this.setState({
									shouldUiBeChanged: false,
								});
							}
							setState({
								isLoading: false,
							});
						}}
					>
						{({ fields, invalidFields }) => (
							<div className="container-2 w-container">
								<LoadingScreen isLoading={state.isLoading}>
									{!this.state.shouldUiBeChanged ? (
										<div className="w-row">
											<div className="column w-col w-col-1 w-col-tiny-tiny-stack"></div>
											<div className="column-2 w-col w-col-5 w-col-tiny-tiny-stack">
												<div className="column-2 w-col w-col-tiny-tiny-stack">
													<h3>
														<Trans i18nKey="userregistration.step_4heading">Who is the primary insured ?</Trans></h3>
													<div className="w-col w-col-tiny-tiny-stack">
														<div className="column-2 w-col w-col-6 w-col-tiny-tiny-stack">
															<input
																id="firstname-input"
																type="text"
																name="first"
																defaultValue={
																	state.triageRequest.profiles
																		? state.triageRequest.profiles.first.trim()
																		: fields.first
																}
																placeholder={i18next.t("userregistration.Firstname")}
																className={
																	invalidFields.first ? "is-error" : ""
																}
															/>
															<div className="errormessagetext1">
																{this.state.firstErrorMsg}
															</div>
														</div>

														<div className="column-2 w-col w-col-6 w-col-tiny-tiny-stack">
															<input
																id="lastname-input"
																type="text"
																defaultValue={
																	state.triageRequest.profiles
																		? state.triageRequest.profiles.last.trim()
																		: fields.last
																}
																placeholder={i18next.t("userregistration.Lastname")}
																name="last"
																className={invalidFields.last ? "is-error" : ""}
															/>
															<div className="errormessagetext">
																{this.state.secondErrorMsg}
															</div>
														</div>
													</div>
													<div className="w-col w-col-tiny-tiny-stack">
														<div className="column-2 w-col w-col-6 w-col-tiny-tiny-stack">
															<input
																id="Calender"
																type="text"
																defaultValue={
																	state.triageRequest.profiles
																		? state.triageRequest.profiles.date.trim()
																		: fields.date
																}
																placeholder={i18next.t("userregistration.user-DOB")}
																name="date"
																pattern="\s{0,}\d{1,2}/\d{1,2}/\d{4}\s{0,}"
																onFocus={(e) => {
																	e.currentTarget.type = "date";
																}}
																onBlur={(e) => {
																	e.currentTarget.placeholder = "DOB (dd/mm/yyyy)"
																}}
															/>
														</div>
														<div className="w-col w-col-6 w-col-tiny-tiny-stack">
															<div className="w-col w-col-tiny-tiny-stack">
																<input
																	id="gender-radio"
																	type="radio"
																	checked={
																		state.triageRequest.userGenderPrimary &&
																		state.triageRequest.userGenderPrimary === "Male"
																	}
																	value="Male"
																	onChange={(e) => {
																		state.triageRequest.userGenderPrimary =
																			e.currentTarget.value;
																	}}
																	name="sex"
																	pattern="[A-Za-z\s]{0,}[\S]{1,}[\s]{0,}"
																	className="w-radio-input"
																/>
																<span className="w-radio w-radio-textsize">
																	<Trans i18nKey="userregistration.radio-male">Male</Trans>
																</span>
															</div>
															<div className="w-col w-col-tiny-tiny-stack">
																<input
																	id="gender-radio-1"
																	type="radio"
																	value="Female"
																	checked={
																		state.triageRequest.userGenderPrimary &&
																		state.triageRequest.userGenderPrimary === "Female"
																	}
																	onChange={(e) => {
																		state.triageRequest.userGenderPrimary =
																			e.currentTarget.value;
																	}}
																	name="sex"
																	pattern="[A-Za-z\s]{0,}[\S]{1,}[\s]{0,}"
																	className="w-radio-input"
																/>
																<span className="w-radio w-radio-textsize">
																	<Trans i18nKey="userregistration.radio-female">Female</Trans>
																</span>
															</div>
														</div>
													</div>
													<div className="w-col w-col-tiny-tiny-stack">
														{this.state.mapLoaded && (
															<PlacesAutocomplete
																value={this.state.geoAddress}
																onChange={this.handleGeoChange}
																onSelect={(address, placeId) => {
																	var request = {
																		placeId: placeId,
																	};
																	new Promise((resolve, reject) => {
																		new google.maps.places.PlacesService(
																			document.createElement("div")
																		).getDetails(request, (place, status) => {
																			if (
																				status ==
																				google.maps.places.PlacesServiceStatus.OK
																			) {
																				let postalCode = "";
																				let country = "";
																				let province = "";
																				let city = "";
																				let street = "";
																				let street_number = "";
																				for (
																					var placesIndex = 0;
																					placesIndex <
																					place.address_components.length;
																					placesIndex++
																				) {
																					for (
																						var streetNumberIndex = 0;
																						streetNumberIndex <
																						place.address_components[placesIndex]
																							.types.length;
																						streetNumberIndex++
																					) {
																						if (
																							place.address_components[placesIndex]
																								.types[streetNumberIndex] ===
																							"street_number"
																						) {
																							street_number =
																								place.address_components[
																									placesIndex
																								].long_name;
																						}
																					}
																					for (
																						var streetIndex = 0;
																						streetIndex <
																						place.address_components[placesIndex]
																							.types.length;
																						streetIndex++
																					) {
																						if (
																							place.address_components[placesIndex]
																								.types[streetIndex] === "route" ||
																							place.address_components[placesIndex]
																								.types[streetIndex] === "street"
																						) {
																							street =
																								place.address_components[
																									placesIndex
																								].long_name;
																						}
																					}
																					for (
																						var cityIndex = 0;
																						cityIndex <
																						place.address_components[placesIndex]
																							.types.length;
																						cityIndex++
																					) {
																						if (
																							place.address_components[placesIndex]
																								.types[cityIndex] ===
																							"administrative_area_level_2" ||
																							place.address_components[placesIndex]
																								.types[cityIndex] === "locality"
																						) {
																							city =
																								place.address_components[
																									placesIndex
																								].long_name;
																						}
																					}
																					for (
																						var provinceIndex = 0;
																						provinceIndex <
																						place.address_components[placesIndex]
																							.types.length;
																						provinceIndex++
																					) {
																						if (
																							place.address_components[placesIndex]
																								.types[provinceIndex] ===
																							"administrative_area_level_1"
																						) {
																							province =
																								place.address_components[
																									placesIndex
																								].long_name;
																						}
																					}
																					for (
																						var countryIndex = 0;
																						countryIndex <
																						place.address_components[placesIndex]
																							.types.length;
																						countryIndex++
																					) {
																						if (
																							place.address_components[placesIndex]
																								.types[countryIndex] === "country"
																						) {
																							country =
																								place.address_components[
																									placesIndex
																								].long_name;
																						}
																					}
																					for (
																						var postalIndex = 0;
																						postalIndex <
																						place.address_components[placesIndex]
																							.types.length;
																						postalIndex++
																					) {
																						if (
																							place.address_components[placesIndex]
																								.types[postalIndex] ===
																							"postal_code"
																						) {
																							postalCode =
																								place.address_components[
																									placesIndex
																								].long_name;
																						}
																					}
																				}
																				this.setState({
																					geoAddress: address,
																				});
																				state.triageRequest.street = street;
																				state.triageRequest.city = city;
																				state.triageRequest.country = country;
																				state.triageRequest.street_number = street_number;
																				state.triageRequest.postalCode = postalCode;
																				state.triageRequest.province = province;
																				resolve(place);
																			} else {
																				reject();
																			}
																		});
																	});
																}}
																id="address-input"
																name="house"
																className={invalidFields.house ? "is-error" : "text-field w-select"}
															>
																{({
																	getInputProps,
																	suggestions,
																	getSuggestionItemProps,
																	loading,
																}) => (
																	<div>
																		<input
																			{...getInputProps({
																				placeholder: homecity,
																				className: dynamicClass,
																			})}
																		/>

																		<div className="autocomplete-dropdown-container">
																			{loading && <div>Loading...</div>}
																			{suggestions.map((suggestion) => {
																				const className = suggestion.active
																					? "suggestion-item--active"
																					: "suggestion-item";
																				const style = suggestion.active
																					? {
																						backgroundColor: "#fafafa",
																						cursor: "pointer",
																					}
																					: {
																						backgroundColor: "#ffffff",
																						cursor: "pointer",
																					};
																				return (
																					<div
																						{...getSuggestionItemProps(suggestion, {
																							className,
																							style,
																						})}
																					>
																						<span>{suggestion.description}</span>
																					</div>
																				);
																			})}
																		</div>
																	</div>
																)}
															</PlacesAutocomplete>
														)}
													</div>
													{/* <div className="column-2 w-col w-col-tiny-tiny-stack"> */}
														<div className="w-col w-col-tiny-tiny-stack">
															<PhoneInput
																id="phone-input"
																specialLabel=""
																autocomplete="off"
																autoFormat="true"																
																enableSearch="true"
																value={
																	state.triageRequest.profiles && state.triageRequest.profiles.phone
																		? state.triageRequest.profiles.phone.trim()
																		: fields.phone
																}
																name="phone1"
																localization={
																	{
																		'de': 'Deutschland',
																		'es': 'España',
																		'fr': 'Francais',
																		'en': 'English'
																	}
																}
																placeholder={i18next.t("userregistration.user-phonenumber")}
																
																containerClass=""
																inputClass="tel-input text-field w-input"
																isValid = {(value, country) => {
																	if (value.match(/12345/)) {
																		return 'Invalid value: ' + value + ', ' + country.name;
																	} else if (value.match(/1234/)) {
																		return false;
																	} else {
																		return true;
																	}
																}}
																onChange={phone => this.setState({ phone })}
															
															/>
															</div>
														<div className="w-col w-col-tiny-tiny-stack">
																<select id="RelationList" className="control-shape w-select text-field">
																	<option value="Self">{i18next.t("userregistration.step4_select.self")}</option>
																	<option value="Child">{i18next.t("userregistration.step4_select.child")} </option>
																	<option value="Employee">{i18next.t("userregistration.step4_select.employee")}</option>
																	<option value="Father">{i18next.t("userregistration.step4_select.father")}</option>
																	<option value="Mother">{i18next.t("userregistration.step4_select.mother")}</option>
																	<option value="Brother">{i18next.t("userregistration.step4_select.brother")}</option>
																	<option value="Sister">{i18next.t("userregistration.step4_select.sister")}</option>
																	<option value="Foster Child">{i18next.t("userregistration.step4_select.fosterchild")}</option>
																	<option value="Grandfather">{i18next.t("userregistration.step4_select.grandfather")}</option>
																	<option value="Grandmother">{i18next.t("userregistration.step4_select.grandmother")}</option>
																	<option value="Grandson or Granddaughter">{i18next.t("userregistration.step4_select.grandsonorgranddaughter")}</option>
																	<option value="Life Partner">{i18next.t("userregistration.step4_select.lifepartner")}</option>
																	<option value="Nephew">{i18next.t("userregistration.step4_select.nephew")}</option>
																	<option value="Niece">{i18next.t("userregistration.step4_select.niece")}</option>
																	<option value="Husband">{i18next.t("userregistration.step4_select.husband")}</option>
																	<option value="Wife">{i18next.t("userregistration.step4_select.wife")}</option>
																	<option value="Sponsored Dependent">{i18next.t("userregistration.step4_select.sponsoreddependent")}</option>
																	<option value="Stepson">{i18next.t("userregistration.step4_select.stepson")}</option>
																	<option value="Stepdaughter">{i18next.t("userregistration.step4_select.stepdaughter")}</option>
																	<option value="Other Relationship">{i18next.t("userregistration.step4_select.otherrelationship")}</option>
																</select>
															</div>
													{/* </div> */}

													<div id="agree">
														<span>
															<Trans i18nKey="userregistration.toggle-msg1">
																By clicking Done, I agree that I have read
														and accepted the{" "}
															</Trans> <span id="sign">
																<Trans i18nKey="userregistration.toggle-msg2"> Terms of Use.</Trans>
															</span>
														</span>
														<span>
															<br />
															<br />
															<Trans i18nKey="userregistration.toggle-msg3">See our</Trans>
															<span id="sign"> <Trans i18nKey="userregistration.toggle-msg4">Privacy Policy</Trans> </span>
															<Trans i18nKey="userregistration.toggle-msg5">for more details or to opt-out at any time.
															</Trans>
														</span>
													</div>
													<div className="w-col w-col-tiny-tiny-stack continue-btn">
														<button type="submit" className="button1 btn standby-button-gradient standby-button-gradient-blue btn-blue-rounded">
															<Trans i18nKey="userregistration.done">Done</Trans>
														</button>
													</div>
												</div>
											</div>
											<div className="w-col w-col-6 w-col-tiny-tiny-stack">
												<img src={terms} className="t-img" />
											</div>
										</div>
									) : (
										<UserCreatedSuccessfully {...{
											...this.props
										}} />
									)}
								</LoadingScreen>
							</div>
						)}
					</Form>
				</div>
			);
		}
	}
}
export default Profiles;
